import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { assignTestId } from '@common/infra/tests/assign-test-id';
import NavigationLink from '@common/navigation/navigation-link';
import { Badge } from '@common/badge';
import { getProfileUrl } from '../functions';
import styles from '../profiles-admin-body.css';
export function ProfilesTableTitle({ title, id, isDefault }) {
    return (_jsxs("div", { className: styles.title, children: [_jsx(NavigationLink, { ...assignTestId('profile-link', 'profile-title', {
                    'profile-default': isDefault
                }), href: getProfileUrl(id), children: title }), isDefault ? (_jsx(Badge, { "data-test": "default-profile-badge", className: styles.badge, variant: Badge.variant.Filled, color: Badge.color.Disabled, size: Badge.size.Md, children: "Default" })) : null] }));
}
